export const filterProperties = (originalObject, wantedServerProperties) => {
  return Object.keys(originalObject).filter(key => wantedServerProperties.includes(key)).reduce((obj, key) => {
    obj[key] = originalObject[key]
    return obj
  }, {})
}
